import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

// dialog
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import FeedbackIcon from "@material-ui/icons/Feedback";

import { useStyles, CssTextField } from "./classes";
import * as api from "../../api/index.js";

// validation
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
// import { Box } from '@material-ui/core';

//dialog close styles
// add git check
const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

let initialValues = {
  feed: "",
};

let feedSchema = Yup.object().shape({
  feed: Yup.string()
    .required("Your feedback is required!")
    .max(500, "Max length for the password is 15."),
});

const Feedback = ({ name, id }) => {
  const classes = useStyles();

  const [isSuccess, setIsSuccess] = useState(false);
  const [isServerError, setIsServerError] = useState(false);

  const user = JSON.parse(localStorage.getItem("profile"));

  const submit = async (e) => {
    try {
      var current = new Date();
      const formData = {
        feed: e.feed,
        userId: user.id,
        view: current.toLocaleDateString(),
        resName: name,
        restaurantId: id,
      };
  
      await api.addFeeed(formData);

      setIsSuccess(true);

      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
      setTimeout(() => {
        setOpen(false);
      }, 3500);
    } catch (error) {
      setIsServerError(true);
      setTimeout(() => {
        setIsServerError(false);
      }, 3000);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div>
        {user && (
          <Button
            startIcon={<FeedbackIcon />}
            className={classes.linkButton}
            disableRipple
            onClick={handleClickOpen}
          >
            {" "}
            Add FeedBack
          </Button>
        )}

        <Dialog
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            style: { borderRadius: 50, padding: 0, margin: 0, height: 350 },
          }}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogContent style={{ padding: 0, margin: 0 }}>
            <div>
              <DialogTitle
                id="customized-dialog-title"
                onClose={handleClose}
              ></DialogTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alginItem: "center",
                  alginSelf: "center",
                  marginTop: 10,
                  marginBottom: 20,
                }}
              >
                <Typography className={classes.subtitle}>
                  Create Your Restaurant{" "}
                  <span className={classes.spanText}>Feedback</span>
                </Typography>
              </div>

              <Formik
                initialValues={initialValues}
                onSubmit={submit}
                validationSchema={feedSchema}
              >
                {({ dirty, isValid, resetForm }) => {
                  return (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alginItem: "center",
                          alginSelf: "center",
                          marginTop: 10,
                          marginBottom: 20,
                        }}
                      >
                        <Field
                          name="feed"
                          placeholder="  Add Feedback here.."
                          multiline
                          rows={3}
                          component={CssTextField}
                          className={classes.field}
                          variant="outlined"
                          fullWidth
                        ></Field>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignContent: "space-between",
                          alignItems: "space-between",
                          marginTop: 70,
                        }}
                      >
                        <Button
                          variant="contained"
                          className={classes.button}
                          disabled={!dirty || !isValid}
                          type="submit"
                        >
                          submit
                        </Button>
                        <Button
                          variant="contained"
                          className={classes.cancel}
                          onClick={resetForm}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alginItem: "center",
                  alginSelf: "center",
                }}
              >
                {isSuccess && (
                  <>
                    <Alert icon={false} severity="success">
                      Feedback added successfully!
                    </Alert>
                  </>
                )}
                {isServerError && (
                  <>
                    <Alert icon={false} severity="error">
                      GottaMenu is currently busy Preparing your menus..!
                    </Alert>
                  </>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default Feedback;
